import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { pageStates } from "@/components/Buy/Payment/PaymentConfigs";
import { ICreditCardAddress } from "@/components/Buy/Interfaces";
import { paymentTypes } from "@/components/Buy/BuyEnums";
import { layoutItemNames } from "@/components/BuyEnhancedCart/DynamicComponents/Config";

export const usePaymentPageStore = defineStore("paymentPage", () => {
  const pageState = ref<pageStates>(pageStates.defaultRadioSelector);
  const displayPaymentMethods = ref<boolean>(false);
  const creditAddress = ref<ICreditCardAddress>();
  const setDisplayPaymentMethods = (val: boolean) => (displayPaymentMethods.value = val);
  const currentPaymentType = ref<string>(paymentTypes.CreditCard);
  const selectedPaymentMethodId = ref<string>("");
  const editPayment = ref<boolean>(true);
  const addedNewCreditCard = ref<boolean>(false);
  const paymentMethodFromFile = ref<boolean>(false);
  const payPalEmail = ref<string>("");

  const paymentEditStep = computed(() => {
    return paymentMethodFromFile.value ? layoutItemNames.paymentAddress : layoutItemNames.cardDetails;
  });

  return {
    pageState,
    creditAddress,
    setDisplayPaymentMethods,
    displayPaymentMethods,
    currentPaymentType,
    selectedPaymentMethodId,
    editPayment,
    addedNewCreditCard,
    paymentMethodFromFile,
    payPalEmail,
    paymentEditStep,
  };
});
